// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-page {
  display: flex;
  padding: 2% 1%;
  height: 75vh;
}

.chat-placeholder {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  font-size: 18px;
}

@media screen and (max-width: 768px) {
  .chat-page {
    flex-direction: column;
    padding: 1% 1%;
  }

  .chat-list {
    width: 100%;
    height: 90%;
    order: 1;
  }

  .chat-tabs button {
    padding: 8px 0;
    font-size: 14px;
  }
  .new-chat-area {
    padding: 8px;
  }
  .chat-search {
    width: 95%;
  }
  .rooms-container {
    max-height: 400px;
  }

  .chat-window {
    width: 100%;
    height: 100%;
    margin: 20px 0;
    order: 2;
  }

  .m-header {
    padding: 8px 12px;
  }
  .header-avatar {
    width: 36px;
    height: 36px;
    margin-right: 12px;
  }
  .chat-header-title {
    font-size: 18px;
  }

  .messages {
    max-height: 450px;
    overflow-y: auto;
    width: 100%;
  }
  .msg-bubble {
    min-width: 12%;
    max-width: 80%;
    padding: 8px 12px 18px 12px;
    font-size: 14px;
  }

  .input-area {
    padding: 8px 12px;
  }
  .m-input {
    padding: 10px 12px;
    font-size: 14px;
  }
  .icon-btn,
  .send-btn {
    font-size: 20px;
    margin: 0 4px;
  }

  .msg-time {
    font-size: 10px;
  }

  .chat-page.chat-active .chat-list {
    display: none;
  }
  .chat-page.chat-active .chat-window {
    order: 1;
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/ChatPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,cAAc;IACd,cAAc;IACd,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;EACA;;IAEE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,QAAQ;IACR,SAAO;EACT;AACF","sourcesContent":[".chat-page {\n  display: flex;\n  padding: 2% 1%;\n  height: 75vh;\n}\n\n.chat-placeholder {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #999;\n  font-size: 18px;\n}\n\n@media screen and (max-width: 768px) {\n  .chat-page {\n    flex-direction: column;\n    padding: 1% 1%;\n  }\n\n  .chat-list {\n    width: 100%;\n    height: 90%;\n    order: 1;\n  }\n\n  .chat-tabs button {\n    padding: 8px 0;\n    font-size: 14px;\n  }\n  .new-chat-area {\n    padding: 8px;\n  }\n  .chat-search {\n    width: 95%;\n  }\n  .rooms-container {\n    max-height: 400px;\n  }\n\n  .chat-window {\n    width: 100%;\n    height: 100%;\n    margin: 20px 0;\n    order: 2;\n  }\n\n  .m-header {\n    padding: 8px 12px;\n  }\n  .header-avatar {\n    width: 36px;\n    height: 36px;\n    margin-right: 12px;\n  }\n  .chat-header-title {\n    font-size: 18px;\n  }\n\n  .messages {\n    max-height: 450px;\n    overflow-y: auto;\n    width: 100%;\n  }\n  .msg-bubble {\n    min-width: 12%;\n    max-width: 80%;\n    padding: 8px 12px 18px 12px;\n    font-size: 14px;\n  }\n\n  .input-area {\n    padding: 8px 12px;\n  }\n  .m-input {\n    padding: 10px 12px;\n    font-size: 14px;\n  }\n  .icon-btn,\n  .send-btn {\n    font-size: 20px;\n    margin: 0 4px;\n  }\n\n  .msg-time {\n    font-size: 10px;\n  }\n\n  .chat-page.chat-active .chat-list {\n    display: none;\n  }\n  .chat-page.chat-active .chat-window {\n    order: 1;\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
